import { ActionBar, ButtonVariant } from '@dreryk/react-components';
import { useDraftRemoveByTokenCqrsCommand } from '@dreryk/react-draft';

import { getReferralDraftToken } from '../../referral.draft';
import { referralTranslationKeys } from '../../translations';
import { ReferralToDiagnosticExaminationFormController } from '../ReferralToDiagnosticExaminationForm/ReferralToDiagnosticExaminationForm.types';

import { useReferralToDiagnosticExaminationConfirmAndPrintCommand } from './ReferralToDiagnosticExaminationSendAction.hooks';

type ReferralToDiagnosticExaminationSendActionProps = {
   readonly handleSubmit: ReferralToDiagnosticExaminationFormController['handleSubmit'];
   readonly onSuccess: VoidFunction;
   readonly visitId: number;
};

export const ReferralToDiagnosticExaminationSendAction = (
   props: ReferralToDiagnosticExaminationSendActionProps
): JSX.Element => {
   const { executeAsync: removeDraft } = useDraftRemoveByTokenCqrsCommand();
   const {
      executeAsync: confirmAndPrintReferralToDiagnosticExamination,
   } = useReferralToDiagnosticExaminationConfirmAndPrintCommand(props.visitId, async () => {
      props.onSuccess();
      await removeDraft({ token: getReferralDraftToken('referralToDiagnosticExamination', props.visitId) });
   });
   return (
      <ActionBar.PrimaryButton
         variant={ButtonVariant.PRIMARY}
         onClick={props.handleSubmit(confirmAndPrintReferralToDiagnosticExamination)}
         label={referralTranslationKeys.actionBar.confirmAndPrint}
         testId={'confirmAndPrint'}
         blockingOperation
      />
   );
};
